import { useTranslation } from 'react-i18next';
import {
  ArrowDownToLine,
  ArrowRightLeft,
  ArrowUpFromLine,
  Percent,
  Pencil,
  ShoppingCart,
  Undo2,
} from 'lucide-react';

const ITEMS = [
  { key: 'deposit', icon: ArrowDownToLine },
  { key: 'withdraw', icon: ArrowUpFromLine },
  { key: 'exchange', icon: ArrowRightLeft },
  { key: 'transfer', icon: ArrowRightLeft },
  { key: 'expense', icon: ShoppingCart },
  { key: 'refund', icon: Undo2 },
  { key: 'adjustment', icon: Pencil },
  { key: 'commission', icon: Percent },
] as const;

export function Legend() {
  const { t } = useTranslation('cabinet');

  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-muted-foreground">
      {ITEMS.map((item) => {
        const Icon = item.icon;
        return (
          <span key={item.key} className="inline-flex min-w-0 max-w-full items-start gap-1.5">
            <Icon className="mt-0.5 h-3.5 w-3.5 shrink-0" />
            <span className="min-w-0">{t(`serviceAccounting.legend.${item.key}`)}</span>
          </span>
        );
      })}
    </div>
  );
}
